import { render } from "./QuranManzilList.vue?vue&type=template&id=53fd9b8a"
import script from "./QuranManzilList.vue?vue&type=script&lang=js"
export * from "./QuranManzilList.vue?vue&type=script&lang=js"
script.render = render

export default script